<div class="list-content">
  @if (rows.length > 0) {
    <div class="table-wrapper" (scroll)="onScroll($event)">
      <table class="sticky-header table table-hover">
        <thead>
          <tr>
            @for (column of columns; track column) {
              <th class="column-header">
                {{ column.caption | translate }}
              </th>
            }
          </tr>
        </thead>
        <tbody class="table-striped">
          @for (row of rows; track row; let i = $index) {
            <tr appListViewItem [class.highlight]="row.highlight">
              @for (column of columns; track column) {
                <td (click)="onRowClicked(row, $event)">
                  <dh-custom-view [viewType]="column.viewType" [value]="row.getValue(column)"></dh-custom-view>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (rows.length === 0) {
    <p class="empty-result-tip">{{ 'COMMON.SEARCH_RESULT_EMPTY' | translate }}</p>
  }

  <div class="button-container">
    <astral-button variant="primary" type="button" icon="plus" [label]="buttonText" [size]="buttonSize" (click)="onButtonClicked($event)"></astral-button>

    <span class="counter">{{ 'COMMON.COUNT' | translate }}: {{ rows.length }}</span>
  </div>
</div>
